/**
 * Idle render scheduler tiers from highest to lowest cadence.
 */
export type RenderTier = 'active' | 'low' | 'minimal' | 'paused';

// Poll cadence per non-active tier.
export const IDLE_RENDER_LOW_DELAY_MS = 100;
export const IDLE_RENDER_MINIMAL_DELAY_MS = 500;

// Time-to-tier thresholds measured from the first clean frame.
export const IDLE_RENDER_LOW_THRESHOLD_MS = 200;
export const IDLE_RENDER_MINIMAL_THRESHOLD_MS = 700;
export const IDLE_RENDER_PAUSED_THRESHOLD_MS = 1700;
